import { MeetingConditionStatus } from '../../../../graphql';
import { FULL_MEET_CONDITION_STATUS } from './constants';
import type { FullMeetConditionStatus } from './types';
import { CONDITION_MEET_TEXT } from './lang';

export const getMeetConditionStatus = (
  status: MeetingConditionStatus,
  deadline: string,
): FullMeetConditionStatus => {
  const deadlineTime = new Date(deadline).getTime();
  const currentTime = new Date().getTime();
  if (
    deadlineTime < currentTime &&
    (status === MeetingConditionStatus.CREATED ||
      status === MeetingConditionStatus.MODIFICATION_REQUIRED)
  ) {
    return FULL_MEET_CONDITION_STATUS.PASSED_DEADLINE;
  }

  return status;
};

export const getSubmissionNotes = (status: FullMeetConditionStatus): string => {
  switch (status) {
    case FULL_MEET_CONDITION_STATUS.PENDING:
      return CONDITION_MEET_TEXT.YOU_HAVE_SUBMITTED;
    case FULL_MEET_CONDITION_STATUS.APPROVED:
      return CONDITION_MEET_TEXT.YOU_HAVE_MET;
    case FULL_MEET_CONDITION_STATUS.REJECTED:
      return CONDITION_MEET_TEXT.CONDITION_REJECTED;
    case FULL_MEET_CONDITION_STATUS.CANCELLED:
      return CONDITION_MEET_TEXT.CONDITION_CANCELED;
    case FULL_MEET_CONDITION_STATUS.PASSED_DEADLINE:
      return CONDITION_MEET_TEXT.PASSED_DEADLINE;
    default:
      return '';
  }
};

export const shouldApplicantUpdate = (
  status: FullMeetConditionStatus,
): boolean => {
  switch (status) {
    case FULL_MEET_CONDITION_STATUS.CREATED:
    case FULL_MEET_CONDITION_STATUS.MODIFICATION_REQUIRED:
      return true;
    default:
      return false;
  }
};

export const shouldAdminUpdate = (status: FullMeetConditionStatus): boolean => {
  switch (status) {
    case FULL_MEET_CONDITION_STATUS.PENDING:
      return true;
    default:
      return false;
  }
};
